import axios from "axios";
import { SERVICEURL } from "../appconfig";

export interface GetPhoneDetailResponse {
  phoneId: string;
  phoneNo: string;
  communicationParameterId?: string;
}

export interface UpdatePhonePayload {
  phoneId: string;
  phoneNo: string;
  communicationParameterId?: string;
}

export const getPhoneDetail = async (
  id: string
): Promise<GetPhoneDetailResponse> => {
  const token = localStorage.getItem("token");
  const response = await axios.get(
    `${SERVICEURL}api/Candidates/GetPhoneInfoDetail/${id}`,
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }
  );
  const rawData = response.data?.data || response.data;

  const findField = (obj: any, fieldName: string) => {
    const key = Object.keys(obj).find(
      (k) => k.toLowerCase() === fieldName.toLowerCase()
    );
    return key ? obj[key] : undefined;
  };

  return {
    phoneId: String(findField(rawData, "phoneid") ?? ""),
    phoneNo: findField(rawData, "phoneno") ?? "",
    communicationParameterId: findField(rawData, "communicationparameterid")
      ? String(findField(rawData, "communicationparameterid"))
      : undefined,
  };
};

export const updatePhoneInfo = async (
  payload: UpdatePhonePayload
): Promise<void> => {
  const token = localStorage.getItem("token");
  await axios.put(`${SERVICEURL}api/Candidates/UpdatePhobeInfo`, payload, {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  });
};

export const deletePhoneInfo = async (phoneId: string): Promise<void> => {
  const token = localStorage.getItem("token");
  await axios.delete(`${SERVICEURL}api/Candidates/DeletePhoneInfo/${phoneId}`, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
};
